import clsx from "clsx";
import { Children } from "react";

import "./ScrollableList.scss";

interface ScrollableListProps {
  className?: string;
  placeholder: string;
  /** Accessible name for the menu (e.g. for screen readers). Defaults to placeholder. */
  ariaLabel?: string;
  children: React.ReactNode;
}

export const ScrollableList = ({
  className,
  placeholder,
  ariaLabel,
  children,
}: ScrollableListProps) => {
  const isEmpty = !Children.count(children);

  return (
    <div
      className={clsx("ScrollableList__wrapper", className)}
      role="menu"
      aria-label={ariaLabel ?? placeholder}
    >
      {isEmpty ? <div className="empty">{placeholder}</div> : children}
    </div>
  );
};
